<template>
  <div style="background: #FCFBFC">
    <dss-card class="index-model-3" :wrap-width="wrapWidth" title="核心技术能力：真实世界知识图谱和大语言模型的融合迭代能力">
      <div style="margin-top: 60px">
        <v-img :src="coreTech"></v-img>
      </div>
    </dss-card>
  </div>
</template>
<script>

import DssCard from '../dss/dss-card.vue'
import coreTech from '../../../../assets/pc/index/smart/core-tec.png'
export default {
  name: 'coreTechnology',
  components: {DssCard},
  data: () => {
    return {
      coreTech: coreTech
    }
  },
  props: {
    wrapWidth: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/coreTechnology.vue